import { render, staticRenderFns } from "./businessStock.vue?vue&type=template&id=36492a49&scoped=true"
import script from "./businessStock.vue?vue&type=script&lang=js"
export * from "./businessStock.vue?vue&type=script&lang=js"
import style0 from "./businessStock.vue?vue&type=style&index=0&id=36492a49&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36492a49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36492a49')) {
      api.createRecord('36492a49', component.options)
    } else {
      api.reload('36492a49', component.options)
    }
    module.hot.accept("./businessStock.vue?vue&type=template&id=36492a49&scoped=true", function () {
      api.rerender('36492a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/businessStock.vue"
export default component.exports